// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Product$Showside from "../types/Product.bs.js";
import * as Category$Showside from "../types/Category.bs.js";
import * as Scrollable$Showside from "./Scrollable.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
import * as IconArrowLeft$Showside from "../icons/IconArrowLeft.bs.js";
import * as IconArrowRight$Showside from "../icons/IconArrowRight.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as DesktopPhotoGrid$Showside from "./DesktopPhotoGrid.bs.js";
import * as PDPContentHeader$Showside from "./PDPContentHeader.bs.js";
import * as PDPContentMobile$Showside from "./PDPContentMobile.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as PDPContentDetails$Showside from "./PDPContentDetails.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as PDPContentDetailsCard$Showside from "./PDPContentDetailsCard.bs.js";
function PDPContentDesktop$HeaderTitle(Props) {
  var productCategory = Props.productCategory;
  var match = RouterProvider$Showside.useRouter(undefined);
  var listPageType = match.listPageType;
  var goTo = match.goTo;
  var match$1 = EntrypointContext$Showside.use(undefined);
  var onHistoryClick = match$1.onHistoryClick;
  var onFavoritesClick = match$1.onFavoritesClick;
  var isDeeplinked = match$1.embedType !== /* ProductDetailsPage */5;
  var title;
  if (listPageType !== undefined && typeof listPageType === "number") {
    switch (listPageType) {
      case /* Favorites */0:
        title = "Favorites";
        break;
      case /* History */1:
        title = "Recently Viewed";
        break;
      case /* StoreCart */2:
        title = productCategory.title;
        break;
    }
  } else {
    title = productCategory.title;
  }
  var handleClick = isDeeplinked ? function (e) {
    e.preventDefault();
    if (listPageType !== undefined && typeof listPageType === "number") {
      switch (listPageType) {
        case /* Favorites */0:
          return Curry._1(onFavoritesClick, undefined);
        case /* History */1:
          return Curry._1(onHistoryClick, undefined);
        case /* StoreCart */2:
          break;
      }
    }
    Curry._3(goTo, undefined, undefined, {
      TAG: /* ListPage */1,
      _0: {
        listPageType: {
          TAG: /* Category */0,
          _0: productCategory.id
        },
        viewPLP: false,
        filters: undefined,
        sort: undefined
      }
    });
  } : undefined;
  var tmp;
  if (handleClick !== undefined) {
    tmp = React.createElement("a", {
      className: CSS$Showside.prefix("!text-primary !no-underline"),
      href: "#",
      onClick: handleClick
    }, title);
  } else {
    var tmp$1 = {
      className: CSS$Showside.prefix(Cn.make(["!text-primary !no-underline", Category$Showside.getCategoryLink(productCategory) === undefined ? "cursor-default" : "cursor-pointer"]))
    };
    var tmp$2 = Category$Showside.getCategoryLink(productCategory);
    if (tmp$2 !== undefined) {
      tmp$1.href = Caml_option.valFromOption(tmp$2);
    }
    tmp = React.createElement("a", tmp$1, title);
  }
  return React.createElement(DataAttribute$Showside.make, {
    dataTestId: "pdp-category-link",
    children: tmp
  });
}
PDPContentDesktop$HeaderTitle.displayName = "PDPContentDesktop.HeaderTitle";
var HeaderTitle = {
  make: PDPContentDesktop$HeaderTitle
};
function PDPContentDesktop$StaticHeader(Props) {
  var product = Props.product;
  var productCategory = Props.productCategory;
  var routeProductId = Props.routeProductId;
  var config = Props.config;
  var settings = Props.settings;
  var match = RouterProvider$Showside.useRouter(undefined);
  var goTo = match.goTo;
  var route = match.route;
  var match$1 = PDPContentMobile$Showside.useProductPosition(config, productCategory, settings, routeProductId, product);
  var products = match$1[2];
  var productsCount = match$1[1];
  var productPosition = match$1[0];
  var goToProduct = function (direction) {
    var position = direction === "left" ? productPosition !== undefined ? productPosition - 1 | 0 : 0 : direction === "right" && productPosition !== undefined ? productPosition + 1 | 0 : 0;
    var nextProduct = Belt_Array.get(products, position);
    if (nextProduct === undefined) {
      return;
    }
    if (typeof route !== "number") {
      switch (route.TAG | 0) {
        case /* PDP */2:
          var match = route._0;
          return Curry._3(goTo, undefined, undefined, {
            TAG: /* PDP */2,
            _0: {
              categoryId: match.categoryId,
              productCategoryId: Belt_Option.orElse(match.productCategoryId, productCategory.id),
              productId: nextProduct.id,
              variantId: undefined,
              zoomedPhotoIndex: undefined
            }
          });
        case /* QuickView */3:
          var match$1 = route._0;
          return Curry._3(goTo, undefined, undefined, {
            TAG: /* QuickView */3,
            _0: {
              mediaId: match$1.mediaId,
              mediaParentId: match$1.mediaParentId,
              albumId: undefined,
              productId: nextProduct.id,
              relatedMediaProductIds: match$1.relatedMediaProductIds,
              relatedMediaCategoryId: match$1.relatedMediaCategoryId,
              variantId: undefined,
              panelClosed: match$1.panelClosed,
              zoomedPhotoIndex: undefined,
              time: undefined
            }
          });
        default:
      }
    }
    Curry._3(goTo, undefined, undefined, {
      TAG: /* PDP */2,
      _0: {
        categoryId: productCategory.id,
        productCategoryId: productCategory.id,
        productId: nextProduct.id,
        variantId: undefined,
        zoomedPhotoIndex: undefined
      }
    });
  };
  return React.createElement("div", {
    className: CSS$Showside.prefix("flex justify-between items-center text-lg mb-4 h-9")
  }, Belt_Option.getWithDefault(productPosition, 0) > 0 && productsCount > 1 ? React.createElement("button", {
    className: CSS$Showside.prefix("flex items-center gap-2 bg-transparent cursor-pointer text-primary w-44 no-underline group-2 hover:underline whitespace-nowrap font-medium"),
    onClick: function (e) {
      e.preventDefault();
      goToProduct("left");
    }
  }, React.createElement("div", {
    className: CSS$Showside.prefix("transform scale-60 w-12 h-12 flex items-center flex-shrink-0 justify-center rounded-full ring-2 ring-primary text-primary group-2-hover:bg-primary group-2-hover:text-main")
  }, React.createElement(IconArrowLeft$Showside.make, {})), "PREVIOUS PRODUCT") : React.createElement("div", {
    className: CSS$Showside.prefix("w-44")
  }), React.createElement("div", {
    className: CSS$Showside.prefix("text-center text-primary flex justify-center gap-6")
  }, React.createElement(PDPContentDesktop$HeaderTitle, {
    productCategory: productCategory
  }), productsCount > 1 ? React.createElement("span", undefined, String(Belt_Option.getWithDefault(productPosition, 0) + 1 | 0) + "/" + String(productsCount)) : null), Belt_Option.getWithDefault(productPosition, 0) < (productsCount - 1 | 0) ? React.createElement("button", {
    className: CSS$Showside.prefix("flex items-center gap-2 text-primary w-44 justify-end bg-transparent cursor-pointer no-underline group-2 hover:underline whitespace-nowrap font-medium"),
    onClick: function (e) {
      e.preventDefault();
      goToProduct("right");
    }
  }, "NEXT PRODUCT", React.createElement("div", {
    className: CSS$Showside.prefix("transform scale-60 w-12 h-12 flex items-center flex-shrink-0 justify-center rounded-full ring-2 ring-primary text-primary group-2-hover:bg-primary group-2-hover:text-main")
  }, React.createElement(IconArrowRight$Showside.make, {}))) : React.createElement("div", {
    className: CSS$Showside.prefix("w-44")
  }));
}
PDPContentDesktop$StaticHeader.displayName = "PDPContentDesktop.StaticHeader";
var StaticHeader = {
  make: PDPContentDesktop$StaticHeader
};
function PDPContentDesktop$Layout(Props) {
  var photos = Props.photos;
  var basicInfo = Props.basicInfo;
  var moreInfo = Props.moreInfo;
  var match = ConfigurationProvider$Showside.use(undefined).config;
  var match$1 = match.settings.desktopPDPLayout;
  switch (match$1) {
    case /* Old */0:
    case /* Horizontal */1:
      break;
    case /* Vertical */2:
      return React.createElement(React.Fragment, undefined, React.createElement("div", {
        className: CSS$Showside.prefix("w-full relative m-auto")
      }, photos), React.createElement("div", {
        className: CSS$Showside.prefix("w-full relative m-auto"),
        style: {
          maxWidth: "1400px"
        }
      }, basicInfo));
  }
  return React.createElement("div", {
    className: CSS$Showside.prefix("w-full relative m-auto grid gap-13"),
    style: {
      gridTemplateColumns: "1fr 384px"
    }
  }, React.createElement("div", undefined, photos), React.createElement("div", undefined, React.createElement("div", {
    className: CSS$Showside.prefix("sticky top-0")
  }, basicInfo)), React.createElement("div", {
    className: CSS$Showside.prefix("col-span-2")
  }, moreInfo));
}
PDPContentDesktop$Layout.displayName = "PDPContentDesktop.Layout";
var Layout = {
  make: PDPContentDesktop$Layout
};
function PDPContentDesktop(Props) {
  var product = Props.product;
  var variant = Props.variant;
  var productCategory = Props.productCategory;
  var shouldForceMobile = Props.shouldForceMobile;
  var isInsideQuickView = Props.isInsideQuickView;
  var routeProductId = Props.routeProductId;
  var routeVariantId = Props.routeVariantId;
  var viewport = Props.viewport;
  var scrollableContainerRef = Props.scrollableContainerRef;
  var scrollToRef = Props.scrollToRef;
  var onProductClick = Props.onProductClick;
  var onScroll = Props.onScroll;
  var config = Props.config;
  var quantity = Props.quantity;
  var setQuantity = Props.setQuantity;
  var showMoreProducts = Props.showMoreProducts;
  var renderLauncher = Props.renderLauncher;
  var match = ConfigurationProvider$Showside.use(undefined).config;
  var settings = match.settings;
  ViewportContext$Showside.use(undefined);
  EntrypointContext$Showside.use(undefined);
  RouterProvider$Showside.useRouter(undefined);
  var hideMediaFromOtherVariants = Belt_Option.mapWithDefault(match.transitiveAccount, false, function (account) {
    return account.pdpHideMediaFromOtherVariants;
  });
  var selectedVariant = Belt_Option.getWithDefault(Belt_Option.flatMap(routeVariantId, function (param) {
    return Product$Showside.getVariantById(product, param);
  }), product.firstVariant);
  var allVariantMedia = React.useMemo(function () {
    return Product$Showside.getAllVariantMedia(hideMediaFromOtherVariants, product, selectedVariant);
  }, [selectedVariant.id, product.id]);
  var stickyDetailsRef = React.useRef(function (visible) {});
  var scrollToDetails = React.useCallback(function (param) {
    Curry._1(scrollToRef.current, /* Top */0);
  }, []);
  var scrollToDetailsRef = React.useRef(scrollToDetails);
  var relatedProductsLayout = React.useMemo(function () {
    return {
      TAG: /* GridLayout */1,
      _0: {
        columns: /* FourColumnGrid */3,
        gap: /* Half */1,
        maxRows: undefined,
        maxWidth: undefined,
        padding: undefined,
        pattern: undefined
      }
    };
  }, []);
  var match$1 = React.useState(function () {
    return /* Visible */3;
  });
  var setCTAVisible = match$1[1];
  var ctaVisible = match$1[0];
  var handleCTAButtonVisibilityChange = function (visible) {
    Curry._1(setCTAVisible, function (param) {
      return visible;
    });
  };
  var moreSections = PDPContentDetails$Showside.useMoreSections(onProductClick, viewport, false, productCategory, undefined, undefined, undefined, undefined, true, settings.desktopPDPLayout === /* Vertical */2 ? /* Accordion */1 : /* Hidden */0, shouldForceMobile, relatedProductsLayout, scrollableContainerRef, product.id, undefined, product, selectedVariant, undefined);
  var match$2 = settings.desktopPDPLayout;
  var match$3 = settings.desktopPDPLayout;
  var tmp;
  if (ctaVisible !== 0) {
    switch (ctaVisible) {
      case /* HiddenBottom */1:
        tmp = true;
        break;
      case /* Hidden */2:
        tmp = match$3 !== 1;
        break;
      case /* Visible */3:
        tmp = false;
        break;
    }
  } else {
    tmp = match$3 !== 1;
  }
  var tmp$1 = {
    product: product,
    productCategory: productCategory,
    settings: settings
  };
  if (routeProductId !== undefined) {
    tmp$1.routeProductId = routeProductId;
  }
  if (config !== undefined) {
    tmp$1.config = Caml_option.valFromOption(config);
  }
  var match$4 = settings.desktopPDPLayout;
  var match$5 = settings.desktopPDPLayout;
  var match$6 = settings.desktopPDPLayout;
  var match$7 = settings.desktopPDPLayout;
  var tmp$2 = {
    product: product,
    variant: variant,
    productCategory: productCategory,
    shouldForceMobile: shouldForceMobile,
    isInsideQuickView: isInsideQuickView,
    viewport: viewport,
    scrollableContainerRef: scrollableContainerRef,
    scrollToDetailsRef: scrollToDetailsRef,
    stickyDetailsRef: stickyDetailsRef,
    showHeader: true,
    collapsible: false,
    titleStyle: "normal",
    largeTitleStyle: "medium",
    optionSize: /* Md */2,
    optionStyle: /* Border */0,
    colorOptionSize: /* Xxl */5,
    hideRelatedProductId: product.id,
    showEnhanceContent: settings.desktopPDPLayout === /* Vertical */2,
    showRelatedMedia: settings.desktopPDPLayout === /* Vertical */2,
    showMoreProducts: Belt_Option.getWithDefault(showMoreProducts, settings.desktopPDPLayout === /* Vertical */2),
    descriptionLayout: /* Hidden */0,
    onCTAButtonVisibilityChange: handleCTAButtonVisibilityChange,
    onProductClick: onProductClick,
    quantity: quantity,
    setQuantity: setQuantity,
    stickyCTA: false,
    relatedProductsLayout: relatedProductsLayout,
    layout: match$7 >= 2 ? /* TwoColumns */1 : /* SingleColumn */0,
    separator: false,
    headerSize: /* Large */1,
    sections: ["promo", "detailed", "variants", "quantity", "cta", "summary"]
  };
  var tmp$3 = settings.desktopPDPLayout === /* Vertical */2 ? undefined : "";
  if (tmp$3 !== undefined) {
    tmp$2.singleColumnHorizontalPadding = Caml_option.valFromOption(tmp$3);
  }
  var match$8 = settings.desktopPDPLayout;
  return React.createElement(DataAttribute$Showside.make, {
    dataTestId: "pdp",
    children: React.createElement(Scrollable$Showside.make, {
      restorationId: isInsideQuickView ? "smartnav-pdp-qv" : "smartnav-pdp-nav",
      scrollToRef: scrollToRef,
      onScroll: onScroll,
      children: null,
      fwdRef: scrollableContainerRef,
      className: CSS$Showside.prefix("flex flex-col absolute inset-0 bg-main p-17"),
      rememberScrollPosition: false
    }, React.createElement("div", {
      className: CSS$Showside.prefix("w-full relative m-auto")
    }, React.createElement(PDPContentHeader$Showside.make, {
      product: product,
      variant: selectedVariant,
      settings: settings,
      scrollToDetails: scrollToDetails,
      scrollableContainerRef: scrollableContainerRef,
      position: match$2 !== 1 ? /* FixedBottom */2 : /* FixedTop */3,
      animateVisibility: tmp,
      shadow: true,
      bg: false,
      image: true,
      showCTA: false,
      promoText: true,
      reviews: true,
      maxWidth: "1400px",
      size: /* Lg */1,
      variants: true,
      quantity: quantity,
      setQuantity: setQuantity,
      optionSize: /* Md */2,
      optionStyle: /* Dropdown */2,
      colorOptionSize: /* Xl */4,
      titleStyle: "normal",
      largeTitleStyle: "medium",
      titleSize: "small",
      quantityOptionSize: /* Sm */1
    }), Belt_Option.mapWithDefault(renderLauncher, null, function (fn) {
      return Curry._1(fn, CSS$Showside.prefix("-mt-7 mb-7"));
    }), React.createElement(PDPContentDesktop$StaticHeader, tmp$1)), React.createElement(PDPContentDesktop$Layout, {
      photos: React.createElement(DesktopPhotoGrid$Showside.make, {
        product: product,
        variantId: selectedVariant.id,
        productCategory: productCategory,
        medias: allVariantMedia,
        viewport: viewport,
        settings: settings,
        containerWidthAdjustment: match$4 !== 1 ? 0 : -524,
        maxContainerHeight: match$5 !== 1 ? 1000 : 1400,
        maxCount: match$6 !== 1 ? 4 : 3
      }),
      basicInfo: React.createElement(PDPContentDetails$Showside.make, tmp$2),
      moreInfo: React.createElement("div", undefined, match$8 !== 0 ? null : React.createElement(PDPContentDetailsCard$Showside.DetailedAccordions.make, {
        variant: selectedVariant,
        product: product
      }), React.createElement(PDPContentDetailsCard$Showside.MoreSections.make, {
        product: product,
        moreSections: moreSections
      }))
    }))
  });
}
PDPContentDesktop.displayName = "PDPContentDesktop";
var make = PDPContentDesktop;
export { HeaderTitle, StaticHeader, Layout, make };
/* react Not a pure module */